module.exports = __webpack_public_path__ + "static/img/donnie.7a125ee.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success-stories/donnie.jpeg
// module id = o4GH
// module chunks = 0